// noinspection JSUnusedGlobalSymbols

export enum KeyboardKey {
  Enter = "Enter",
  Escape = "Escape",
  Tab = "Tab",
  ArrowUp = "ArrowUp",
  ArrowDown = "ArrowDown",
  ArrowLeft = "ArrowLeft",
  ArrowRight = "ArrowRight",
  Space = " ",
  Backspace = "Backspace",
  Delete = "Delete",
  Shift = "Shift",
  Control = "Control",
  Alt = "Alt",
  Meta = "Meta", // ⌘ on Mac, Windows key on Windows
}
